import {
  SEED_PATIENTS_REQUEST,
  SEED_PATIENTS_SUCCESS,
  SEED_PATIENTS_FAIL,
  SEED_SUBMIT_REQUEST,
  SEED_SUBMIT_PROGRESS,
  SEED_SUBMIT_SUCCESS,
  SEED_SUBMIT_FAIL,
  SEED_SUBMIT_RESET,
  SEED_LOGS_FETCH_REQUEST,
  SEED_LOGS_FETCH_SUCCESS,
  SEED_LOGS_FETCH_FAIL,
  SEED_REGISTRATION_SAVE_REQUEST,
  SEED_REGISTRATION_SAVE_SUCCESS,
  SEED_REGISTRATION_SAVE_FAIL,
  SEED_REGISTRATION_SAVE_RESET,
  SEED_DEVICE_CYCLES_REQUEST,
  SEED_DEVICE_CYCLES_SUCCESS,
  SEED_DEVICE_CYCLES_FAIL,
  SEED_BILLING_EVAL_REQUEST,
  SEED_BILLING_EVAL_SUCCESS,
  SEED_BILLING_EVAL_FAIL,
  SEED_BILLING_EVAL_RESET,
} from "./constants";

export const seedPatientsReducer = (state = {}, action) => {
  switch (action.type) {
    case SEED_PATIENTS_REQUEST:
      return { loading: true };
    case SEED_PATIENTS_SUCCESS:
      return { loading: false, patients: action.payload };
    case SEED_PATIENTS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const seedSubmitReducer = (state = {}, action) => {
  switch (action.type) {
    case SEED_SUBMIT_REQUEST:
      return { loading: true, progressLogs: [], result: null, error: null };
    case SEED_SUBMIT_PROGRESS:
      return {
        ...state,
        loading: true,
        progressLogs: action.payload.allResults,
      };
    case SEED_SUBMIT_SUCCESS:
      return {
        loading: false,
        result: action.payload,
        progressLogs: action.payload.results || [],
        deviceCycles: action.payload.deviceCycles || null,
      };
    case SEED_SUBMIT_FAIL:
      return { loading: false, error: action.payload };
    case SEED_SUBMIT_RESET:
      return {};
    default:
      return state;
  }
};

export const seedLogsReducer = (state = {}, action) => {
  switch (action.type) {
    case SEED_LOGS_FETCH_REQUEST:
      return { loading: true };
    case SEED_LOGS_FETCH_SUCCESS:
      return { loading: false, logs: action.payload };
    case SEED_LOGS_FETCH_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const seedRegistrationReducer = (state = {}, action) => {
  switch (action.type) {
    case SEED_REGISTRATION_SAVE_REQUEST:
      return { loading: true, error: null, success: false };
    case SEED_REGISTRATION_SAVE_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SEED_REGISTRATION_SAVE_FAIL:
      return { loading: false, success: false, error: action.payload };
    case SEED_REGISTRATION_SAVE_RESET:
      return {};
    default:
      return state;
  }
};

export const seedDeviceCyclesReducer = (state = {}, action) => {
  switch (action.type) {
    case SEED_DEVICE_CYCLES_REQUEST:
      return { ...state, loading: true, error: null };
    case SEED_DEVICE_CYCLES_SUCCESS:
      return {
        loading: false,
        cycles: action.payload.cycles || [],
        patient: action.payload.patient || null,
        activeCycle: action.payload.activeCycle || null,
        error: null,
      };
    case SEED_DEVICE_CYCLES_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const seedBillingEvalReducer = (state = {}, action) => {
  switch (action.type) {
    case SEED_BILLING_EVAL_REQUEST:
      return { loading: true, error: null, success: false };
    case SEED_BILLING_EVAL_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SEED_BILLING_EVAL_FAIL:
      return { loading: false, success: false, error: action.payload };
    case SEED_BILLING_EVAL_RESET:
      return {};
    default:
      return state;
  }
};
